import styled from '@emotion/styled';
import React from 'react';
import { space, SpaceProps } from 'styled-system';

import { dividerStyles } from './Divider.styles';

export type DividerProps = React.HTMLAttributes<HTMLHRElement> &
  SpaceProps & {
    /**
     * Additional CSS class names
     */
    className?: string;
  };

const StyledHr = styled.hr<SpaceProps>`
  ${dividerStyles}
  ${space}
`;

const Divider: React.FC<DividerProps> = ({ className, ...rest }) => {
  return <StyledHr className={className} {...rest} />;
};

export default Divider;
